import React from 'react';
import tinytime from 'tinytime';
import LinkButton from "../../../components/link-button"
import {
    reqAccountList
    , reqBatchActivate
    , reqBatchEditCompany
    , reqBatchEditDefaultGroup
    , reqBatchEditAccountPwd
    , reqBatchDeleteAccount
    , reqDeleteAccount
    , reqEditTempCall
    , reqEditOpenPosition
    , reqEditMobile
    , reqEditPosition
    , reqEditRemark
} from "../../../api"
import SearchBar from "./search-bar"
import BatchActivate from "./batch-activate"
import BatchEditCompany from "./batch-edit-company"
import BatchEditDefaultGroup from "./batch-edit-default-group"
import BatchEditAccountPwd from "./batch-edit-account-pwd"
import BatchDeleteAccount from "./batch-delete-account"
import EditPosition from './batch-edit-position';
import EditMobile from "./edit-mobile/edit-mobile"
import EditRemark from "./edit-remark"
import EditAccount from "./edit-account"
import FileDown from "../../../components/file-down/file-down.jsx"
import { Form, Input } from "antd"
import { connect } from "react-redux"
import {
    TransactionOutlined
    , BranchesOutlined
    , TeamOutlined
    , CloseSquareOutlined
    , EyeInvisibleOutlined
    , EnvironmentOutlined
    , OrderedListOutlined

} from '@ant-design/icons';
import {
    Button
    , Table
    , Switch
    , Space
    , message
    , Popconfirm
    , Popover
    , Checkbox
    , Row
    , Col
} from 'antd';
import "./index.css"
const { Item } = Form;

class AccountList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            currentEditAccountInfo: {},
            loading: false,
            tableLoading: false,
            rowSelection: [],
            selectedRowKeys: [],
            data: [],
            total: 0,
            page: { current: 1, pageSize: 30 },
            options: {
                // order_by: "user_create_time",
                // order_dir: 0
            },
            editMobileVisible: false,
            editRemarkVisible: false,
            batchActivateVisible: false,
            editPositionVisible: false,
            showColums: ['service_begin_time', 'remark']
        }
    }
    componentDidMount() {
        this.getAccountList()
    }
    getAccountList = async () => {
        const { page, options } = this.state
        const { current, pageSize } = page

        this.setState({
            tableLoading: true
        })
        const res = await reqAccountList({ ...options, page_size: pageSize, page_index: current })

        if (res.code === 200) {
            //改变总条数total  展开 「...page」 以确保我们没有 「丢失」 pageSize 和 current
            this.setState({
                tableLoading: false,
                total: res.data.row_count,
                data: res.data.user_list
            })
        } else {
            message.error("获取账号列表失败")
        }
    }
    columns = [
        //  Table.SELECTION_COLUMN,
        {
            title: '登录账号',
            width: 140,
            fixed: 'left',
            align:'center',
            dataIndex: 'user_account',
        },
        {
            title: '账号名称',
            width: 100,
            align:'center',
            dataIndex: 'name',
        },
        {
            title: 'ICCID',
            width: 140,
            align:'center',
            dataIndex: 'iccid',
        },
        {
            title: 'IMEI',
            width: 120,
            align:'center',
            dataIndex: 'imei',
        },
        {
            title: '所属集团',
            width: 90,
            align:'center',
            dataIndex: 'company_name',
        },
        {
            title: '状态',
            width: 40,
            align:'center',
            dataIndex: 'user_enable',
            render: value => {
                switch (value) {
                    case 0: return <span>未激活</span>
                    case 1: return <span>可用</span>
                    case 2: return <span>暂停</span>
                    case 3: return <span>禁言</span>
                    default: return <span>停用</span>
                }
            }
        },
        {

            title: '创建时间',
            width: 120,
            align:'center',
            dataIndex: 'user_create_time',
        },
        {

            title: '启用时间',
            width: 120,
            align:'center',
            // sorter:true,
            dataIndex: 'service_begin_time',
        },
        {
            title: '到期时间',
            width: 120,
            align:'center',
            dataIndex: 'service_end_time',
            sorter: true,
            render: (value) => {
                if (new Date(value).getTime() < new Date().getTime()) {
                    return <div className="endTimeDiv"><span>{value}</span></div>
                } else {
                    return <div><span>{value}</span></div>
                }
            }
        },
        {
            title: '设备ID',
            dataIndex: "device_id",
            width: 90,
            align:'center',
            dataIndex: 'device_id',
        },
        {
            title: '位置服务地址',
            dataIndex: "location_server",
            width: 120,
            align:'center',
            render: (value, record) => {
                return <span>{value ? `${value}:${record.location_server_port}` : ""}</span>
            }
        },
        // {
        //     title: '关联手机号',
        //     width: 80,
        //     dataIndex: 'mobile',
        //     render: (value, record) => {
        //         return <LinkButton onClick={() => { this.setState({ editMobileVisible: true, currentEditAccountInfo: record }); }}>{value ? value : "关联手机号"}</LinkButton>
        //     }
        // },
        {
            title: '备注',
            width: 110,
            ellipsis: true,
            align:'center',
            dataIndex: 'remark',
            render: (value, record) => {
                return <LinkButton onClick={() => { this.setState({ editRemarkVisible: true, currentEditAccountInfo: record }); }}>{value ? value : "备注"}</LinkButton>
            }
        },
        {
            title: '单呼',
            width: 30,
            align:'center',
            dataIndex: 'temp_call',
            render: (value, record) => <Switch size="small" onClick={(checked) => { this.editTempCall(checked, value, record) }} defaultChecked={value} />
        },
        {
            title: '定位',
            width: 30,
            align:'center',
            dataIndex: 'open_position',
            render: (value, record) => <Switch size="small" onClick={(checked) => { this.editOpenPosition(checked, value, record) }} defaultChecked={value} />
        },
        {
            title: '操作',
            width: 100,
            fixed: 'right',
            align:'center',
            render: (text, record) => {
                return (
                    <Space>
                        {
                            record.user_enable === 0 ? null : <LinkButton onClick={() => { this.setState({ currentEditAccountInfo: record, editAccountVisible: true }) }}>修改</LinkButton>
                        }
                        <Popconfirm
                            title="账号删除后不可恢复"
                            onConfirm={() => { this.confirmDeleteSingleAccount(record) }}
                            okText="删除"
                            cancelText="取消"
                        >
                            <LinkButton >删除</LinkButton>
                        </Popconfirm>
                    </Space>
                )
            }
        },
    ]
    editMobile = async (values, form) => {
        const { user_id } = this.state.currentEditAccountInfo
        const { mobile } = values
        const res = await reqEditMobile(user_id, mobile)
        if (res.data.result === 1) {
            // setEMobileVisible(false)
            this.setState({
                editMobileVisible: false
            })
            message.success("修改成功")
            form.resetFields()
            //更新表格
            this.updataTable()
        } else {
            message.error(res.data.err_msg)
        }
    }
    editRemark = async (values, form) => {
        const { user_id } = this.state.currentEditAccountInfo
        let { remark } = values
        remark = remark || "备注"
        const res = await reqEditRemark(user_id, remark)
        if (res.data.result === 1) {
            // setEMobileVisible(false)
            this.setState({
                editRemarkVisible: false
            })
            message.success("修改备注成功")
            form.resetFields()
            //更新表格
            this.updataTable()
        } else {
            message.error(res.data.err_msg)
        }
    }
    //批量激活
    activate = async (values, form) => {
        const res = await reqBatchActivate(this.state.selectedRowKeys.join(","), values.card_type)
        if (res.data.result === 1) {
            // setBatchActivateVisible(false)
            this.setState({
                batchActivateVisible: false
            })
            message.success("激活成功")
            form.resetFields()
            //更新表格
            this.updataTable()
        } else {
            message.error(res.data.err_msg)
        }
    }
    //批量分配
    editCompany = async (values) => {
        const res = await reqBatchEditCompany(this.state.selectedRowKeys.join(","), values.company_id)
        if (res.data.result === 1) {
            // setEditCompanyVisible(false)
            this.setState({
                editCompanyVisible: false
            })
            //更新表格
            message.success("分配成功")
            this.updataTable()
        }
    }
    //     //批量设置默认群组
    editDefaultGroup = async (values) => {
        const res = await reqBatchEditDefaultGroup(this.state.selectedRowKeys.join(","), values.group_id)
        if (res.data.result === 1) {
            // setEditDefaultGroupVisible(false)
            this.setState({
                editDefaultGroupVisible: false
            })
            //更新表格
            message.success("设置默认群组成功")
        }
    }
    //批量设置位置服务
    editPosition = async (values) => {
        const options = {
            user_ids: this.state.selectedRowKeys,
            ...values
        }
        const res = await reqEditPosition(options)
        if (res.data.result === 1) {
            // setEditPositionVisible(false)
            this.setState({
                editPositionVisible: false
            })
            //更新表格
            message.success("设置位置服务成功")
            this.updataTable()
        }
    }
    //     //批量设置账号密码
    editUserPwd = async (values, form) => {
        const res = await reqBatchEditAccountPwd(this.state.selectedRowKeys.join(","), values.pwd)
        if (res.data.result === 1) {
            // setEditUserPwdVisible(false)
            this.setState({
                editUserPwdVisible: false
            })
            form.resetFields()
            //更新表格
            message.success("修改密码成功")
        }
    }
    //批量删除账号
    deleteAccount = async (values) => {
        const res = await reqBatchDeleteAccount(this.state.selectedRowKeys.join(","), values.validate_code)
        if (res.data?.result === 1) {
            this.setState({
                deleteAccountVisible: false
            })
            //更新表格
            message.success("删除成功")
            this.updataTable()
        } else {
            message.error("验证码不正确")
        }
    }
    //刷新表格
    updataTable = async () => {
        const { options } = this.state
        const { current, pageSize } = this.state.page
        const res = await reqAccountList({ ...options, page_size: pageSize, page_index: current })
        //改变总条数total  展开 「...page」 以确保我们没有 「丢失」 pageSize 和 current
        this.setState({
            total: res.data.row_count,
            data: res.data.user_list
        })
    }
    //删除单个账号
    confirmDeleteSingleAccount = async (record) => {
        const { user_id, company_id } = record
        const res = await reqDeleteAccount(user_id, company_id)
        if (res.data.result === 1) {
            message.success("删除成功")
            this.updataTable()
        }
    }
    //设置单呼 
    editTempCall = async (checked, value, record) => {
        //value：账号的当前单呼权限状态
        //checked 开关Swich改变后的状态
        //record 当前操作的行信息
        const { user_id } = record
        const res = await reqEditTempCall(user_id, checked)
        if (res.data.result === 1) {
            message.success("操作成功！")
        }
    }
    editOpenPosition = async (checked, value, record) => {
        //value：账号的当前定位权限状态
        //checked 开关Swich改变后的状态
        //record 当前操作的行信息
        const { user_id } = record
        const res = await reqEditOpenPosition(user_id, checked)
        if (res.data.result === 1) {
            message.success("操作成功！")
        }
    }
    onSearch = async (options) => {

        const range = options.range_time
        if (range) {
            const template = tinytime('{YYYY}/{Mo}/{DD} {H}:{mm}:{ss}')
            options.end_time_start = template.render(new Date(range[0]))
            options.end_time_end = template.render(new Date(range[1]))
        }
        delete options.range_time
        //搜索
        const { current, pageSize } = this.state.page
        // const res = await reqAccountList({ ...options, page_size: pageSize, page_index: 1 })
        const { order_by, order_dir } = this.state.options
        options.order_by = order_by
        options.order_dir = order_dir
        this.setState({
            options,
            page: { current: 1, pageSize }
        }, () => {
            this.getAccountList()
        })
        // setOptions(options)
        // setPage({ current: 1, pageSize })
        // setTotal(res.data.row_count);
        // setData(res.data.user_list)
    }
    //     // 分页、排序、筛选变化时触发
    handleTableChange = (page, filters, sorter) => {

        let { options } = this.state
        const { field, order } = sorter
        //如果不排序 删除掉排序属性
        if (order !== undefined) {
            options = { ...options, order_by: field, order_dir: order === 'ascend' ? 1 : 0 }
        }
        this.setState({
            options,
            page
        }, () => {
            this.getAccountList()
        })

        //改变state 会重新执行 useEffect副作用（发起异步请求获取UserList）
        // setPage(page)
        //分页状态变化 清空当前列表数据 否则可能会引起 total总数据长度 大于 pageSize
        //  Warning: [antd: Table] `dataSource` length is less than `pagination.total` but large than `pagination.pageSize`. Please make sure your config correct data with async mode. 
        // setData([])


    }
    cancelActivate = () => {
        this.setState({
            editAccountVisible: false
        })
    }
    onSelectChange = selectedRow => {
        this.setState({
            selectedRowKeys: selectedRow
        })
    };
    cancelEditCompany = () => {
        this.setState({
            editCompanyVisible: false
        })
    }
    cancelEditDefaultGroup = () => {
        this.setState({
            editDefaultGroupVisible: false
        })
    }
    cancelEditUserPwd = () => {
        this.setState({
            editUserPwdVisible: false
        })
    }
    cancelDeleteAccount = () => {
        this.setState({
            deleteAccountVisible: false
        })
    }
    cancelEditRemark = () => {
        this.setState({
            editRemarkVisible: false
        })
    }
    cancelEditPosition = () => {
        this.setState({
            editPositionVisible: false
        })
    }
    cancelActivate = () => {
        this.setState({
            batchActivateVisible: false
        })
    }
    cancelEditAccount = () => {
        this.setState({
            editAccountVisible: false
        })
    }
    cancelEditMobile = () => {
        this.setState({
            editMobileVisible: false
        })
    }
    columsOnChange = (checkedValues) => {
        console.log(console.log('checked = ', checkedValues))
        this.setState({
            showColums: checkedValues
        })
    }
    //求两个数组的差集
    subSet = function (arr1, arr2) {
        var set1 = new Set(arr1);
        var set2 = new Set(arr2);

        var subset = [];

        for (let item of set1) {
            if (!set2.has(item)) {
                subset.push(item);
            }
        }

        return subset;
    };
    render() {

        const { page, data, total, options, loading, tableLoading, selectedRowKeys, currentEditAccountInfo
            , editAccountVisible
            , editPositionVisible
            , editUserPwdVisible
            , deleteAccountVisible
            , editDefaultGroupVisible
            , editCompanyVisible
            , batchActivateVisible
            , editMobileVisible
            , editRemarkVisible
        } = this.state
        const {
            onSelectChange
            , handleTableChange
            , activate
            , editUserPwd
            , deleteAccount
            , editMobile
            , editRemark
            , editDefaultGroup
            , editCompany
            , onSearch, cancelEditCompany
            , cancelEditDefaultGroup
            , cancelEditUserPwd
            , cancelDeleteAccount
            , cancelEditPosition
            , cancelEditAccount
            , cancelEditMobile
            , cancelEditRemark
            , cancelActivate
            , updataTable
            , editPosition
            , columsOnChange
        } = this

        const rowSelection = {
            selectedRowKeys,
            onChange: onSelectChange,
        }

        const hasSelected = selectedRowKeys.length > 0;
       // 要隐藏的列
        const dfHideColumns = ['imei', 'iccid', 'location_server', 'service_begin_time','remark','user_create_time','device_id'] //, 'mobile'
        //
        const hideColumns = this.subSet(dfHideColumns, this.state.showColums)
        const columns = this.columns.filter(column => {
            return hideColumns.findIndex(i => column?.dataIndex === i) === -1
        })

        return (
            <div className="account-list">
                {/* 头部搜索部分 */}
                <SearchBar onSearch={onSearch}></SearchBar>
                {/* 批量激活模态框组件 */}
                <BatchActivate visible={batchActivateVisible} onCancel={cancelActivate} onSubmit={activate} ></BatchActivate>
                <EditMobile visible={editMobileVisible} onCancel={cancelEditMobile} onSubmit={editMobile}></EditMobile>
                <EditRemark visible={editRemarkVisible} onCancel={cancelEditRemark} onSubmit={editRemark}></EditRemark>
                <BatchEditCompany visible={editCompanyVisible} onCancel={cancelEditCompany} onSubmit={editCompany} ></BatchEditCompany>
                <BatchEditDefaultGroup visible={editDefaultGroupVisible} onCancel={cancelEditDefaultGroup} onSubmit={editDefaultGroup}></BatchEditDefaultGroup>
                <BatchEditAccountPwd visible={editUserPwdVisible} onCancel={cancelEditUserPwd} onSubmit={editUserPwd}></BatchEditAccountPwd>
                <BatchDeleteAccount visible={deleteAccountVisible} onCancel={cancelDeleteAccount} onSubmit={deleteAccount}></BatchDeleteAccount>
                <EditPosition visible={editPositionVisible} onCancel={cancelEditPosition} onSubmit={editPosition} />
                {Object.getOwnPropertyNames(currentEditAccountInfo).length !== 0 ? <EditAccount visible={editAccountVisible} updataAccountTable={updataTable} onCancel={cancelEditAccount} {...currentEditAccountInfo}></EditAccount> : null}
                <div className="account-list-table">
                    <div className="account-list-table-batch">
                        <Space>
                            <Button type="primary" icon={<TransactionOutlined />} disabled={!hasSelected} loading={loading} onClick={() => { this.setState({ batchActivateVisible: true }) }}>
                                充值
                            </Button>
                            <Button type="primary" icon={<BranchesOutlined />} disabled={!hasSelected} loading={loading} onClick={() => { this.setState({ editCompanyVisible: true }) }}>
                                分配
                            </Button>
                            <Button type="primary" icon={<TeamOutlined />} disabled={!hasSelected} loading={loading} onClick={() => { this.setState({ editDefaultGroupVisible: true }) }}>
                                设置默认群组
                            </Button>
                            <Button type="primary" icon={<EnvironmentOutlined />} disabled={!hasSelected} loading={loading} onClick={() => { this.setState({ editPositionVisible: true }) }}>
                                设置位置服务地址
                            </Button>
                            <Button type="primary" icon={<EyeInvisibleOutlined />} disabled={!hasSelected} loading={loading} onClick={() => { this.setState({ editUserPwdVisible: true }) }}>
                                修改密码
                            </Button>
                            <Button type="primary" icon={<CloseSquareOutlined />} disabled={!hasSelected} loading={loading} onClick={() => { this.setState({ deleteAccountVisible: true }) }}>
                                删除
                            </Button>
                            <FileDown loading={loading} api_url="/api/user/get_list_export" options={options} text="导出">
                            </FileDown>
                        </Space>
                        <span style={{ marginLeft: 8 }}>
                            {hasSelected ? `已选中 ${selectedRowKeys.length} 行` : ''}
                        </span>
                        <Popover
                            trigger="click"
                            placement="leftTop"
                            content={<Checkbox.Group
                                onChange={columsOnChange}
                                defaultValue={this.state.showColums}
                            >
                                <Row>
                                    <Col span={8}>
                                        <Checkbox value="iccid">ICCID</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="imei">IEMI</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="service_begin_time">启用时间</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="location_server">位置服务</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="user_create_time">创建时间</Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Checkbox value="device_id">设备ID</Checkbox>
                                    </Col>
                                    {/* <Col span={8}>
                                        <Checkbox value="mobile">关联手机号</Checkbox>
                                    </Col> */}
                                    <Col span={8}>
                                        <Checkbox value="remark">备注</Checkbox>
                                    </Col>

                                </Row>
                            </Checkbox.Group>}
                        >
                            <Button className="btn_custom" icon={<OrderedListOutlined />}>显示列</Button>
                        </Popover>
                    </div>
                    <Table
                        rowSelection={rowSelection}
                        width={1800}
                        columns={columns}
                        dataSource={data}
                        size="small"
                        rowKey="user_id"
                        pagination={{ total: total, defaultPageSize: page.pageSize, pageSizeOptions: [10, 30, 50, 100], current: page.current, showTotal: total => `总记录： ${total} 条`, showQuickJumper: true, position: ["bottomCenter"] }}
                        onChange={handleTableChange}
                        sticky
                        loading={tableLoading}
                        scroll={{ x: 1500 }}
                        bordered
                        // expandable={{
                        //     expandedRowRender: record => <p>{record.remark}</p>,
                        //     rowExpandable: record => !!record.name
                        // }}
                    >
                    </Table>
                </div>
            </div >
        )
    }
}

export default AccountList